type currencyPosition = "prefix" | "suffix";

const formatPrice = (
  price: number,
  currency: string,
  eurShape: string = "€",
  eurPosition: string = "suffix"
): string => {
  //Default currency position
  let currencyPosition: currencyPosition = "suffix";
  let finalCurrency = currency;
  let replaceWith = " ";

  if (currency === "USD") {
    finalCurrency = "$";
    currencyPosition = "prefix";
  } else if (currency === "EUR" || currency === "€") {
    finalCurrency = eurShape;
    currencyPosition =
      eurShape === "€" ? (eurPosition as currencyPosition) : "suffix";
  }

  if (currency === "USD") {
    replaceWith = ",";
  }

  let str = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, replaceWith);

  if (str.includes(".")) {
    const strSplit = str.split(".");

    if (currency !== "USD") {
      str = str.replace(".", ",");
    }

    if (strSplit[1].length === 1) {
      str += "0";
    }
  }

  if (currencyPosition === "suffix") {
    str = `${str} ${finalCurrency}`;
  } else {
    str = `${finalCurrency}${str} `;
  }

  return str.trim();
};

export default formatPrice;
